import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import BannerFadeIn from "./../../components/bannerFadeIn";
import Flodeskform from "./../../components/flodeskForm";
import { withController } from 'react-scroll-parallax';
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";
import { GrumpleAmazonLink, GrumpleSquareLink} from "./../../utils/constants";
import './grumple.css';

class Grumple extends Component {
  render() {
    return (
      <div className="full-height full-width grumple-page">
        <Helmet>
          <title>{'Grumple | A Tahoe Tale of Kindness by Kat Medina'}</title>
          <meta name="description" content="Grumple - A heartwarming Tahoe tale of kindness by Kat Medina." />
        </Helmet>
        <BannerFadeIn>
          <div className="threeQuarter-height full-width black-background background-image-fill centered-text grumple-banner" style={{backgroundImage:"url(/images/grumple-spread.jpg)", height:'70vh'}}></div>
        </BannerFadeIn>
        <ScrollFadeIn>
          <div className="centered-text">
            <div className="">
              <img style={{width:"80%", maxWidth:1000, margin:'auto',marginTop:'-60vh'}} src="/images/grumple-cover.png" />
              <div className="centered-text tiny-padding" style={{margin:'auto', maxWidth:'1000px', marginTop:'-40px', marginBottom:'40px'}}>  
                <div className="row">
                  <div className="small-12 medium-6">
                    <div className="tiny-padding">
                      <a target="_blank" href={GrumpleSquareLink}>
                        <div className="button primary-background white full-width">{'Buy Now'}</div>
                      </a>
                    </div>
                  </div>
                  <div className="small-12 medium-6">
                    <div className="tiny-padding">
                      <a target="_blank" href={GrumpleAmazonLink}>
                        <div className="button primary-background white full-width">{'Buy on Amazon.com'}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <div className="large-padding">
            <img src="/images/grumple-spread-mock.jpg" style={{width:"100%", margin:'auto'}} />
          </div>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <div className="large-padding" style={{paddingTop:0}}>
            <div className="text-max-width-container centered-text">
              <h1>{'The Wild Tale of Grumple The Great'}</h1>
              <ScrollFadeIn>
                <p className="tiny-padding">{`Join Grumple, your not-so-average bear, on his journey to become the best in all the woods.`}</p>
              </ScrollFadeIn>
              <ScrollFadeIn>
              <p className="tiny-padding">{`Through a series of surprisingly silly misadventures, Grumple discovers that being the best isn't always about being the greatest, the fastest, the busiest, or even the stinkiest, but rather, the kindest.`}</p>
              </ScrollFadeIn>
              <ScrollFadeIn>
                <p className="tiny-padding">{`Find out how this bear fares as he attempts to make a bigger-than-big impact on the woods around him in this terrific tale of kindness.`}</p>
              </ScrollFadeIn>
            </div>
          </div>
        </ScrollFadeIn>
        <ScrollFadeIn>  
          <img style={{width:"100%", margin:'auto'}} src="/images/grumple-boat.jpg" />
        </ScrollFadeIn>
        <ScrollFadeIn>
          <Flodeskform />
        </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}

export default withController(Grumple); 


// WEBPACK FOOTER //
// ./src/pages/grumple/index.js